import React from "react";
import * as Yup from "yup";
import CadastroPadrao from "../../../Components/Common/CadastroPadrao";

import {
    getStatusReserva,
    addNewStatusReserva,
    updateStatusReserva,
    deleteStatusReserva
} from "../../../slices/api/statusReserva";

const StatusReserva = () => {
  return (
    <CadastroPadrao
    titulo="Status de Reserva"
    labelSingular="Status de Reserva"
    reduxKey="statusReserva"
    acoesRedux={{
        onGet: getStatusReserva,
        onAddNew: addNewStatusReserva,
        onUpdate: updateStatusReserva,
        onDelete: deleteStatusReserva,
    }}
    colunas={[
        { campo: "id", titulo: "Código" },
        { campo: "nome", titulo: "Nome" },
    ]}
    camposFormulario={[
        {
        nome: "nome",
        label: "Nome",
        placeholder: "Informe o nome do status de reserva",
        validacao: Yup.string().required("Informe o nome do status de reserva"),
        }
    ]}
    />
);
};

export default StatusReserva;
